import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Appbar from "./Appbar";
import Sidebar from "./Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import "../Assets/CSS/BnbConnect.css";
import Web3 from "web3";

const SellReport = () => {
  const location = useLocation();

  const walletAddress =
    location.state?.wallet || localStorage.getItem("walletAddress");

  const tokenAddress = "0x7c96F64a8427dE1F68eceb221E79d4DD2E8d0744";

  const tokenABI = [
    {
      inputs: [
        { internalType: "address", name: "_a1", type: "address" },
        { internalType: "address", name: "_a2", type: "address" },
        { internalType: "address", name: "_a3", type: "address" },
        { internalType: "address", name: "_a4", type: "address" },
        { internalType: "address", name: "_a5", type: "address" },
      ],
      stateMutability: "nonpayable",
      type: "constructor",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Approval",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "user",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "usdt",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "tokens",
          type: "uint256",
        },
      ],
      name: "Buy",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "user",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "claimId",
          type: "uint256",
        },
      ],
      name: "LevelIncomeClaimed",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "user",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "usdt",
          type: "uint256",
        },
      ],
      name: "LevelReward",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "user",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "tokens",
          type: "uint256",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "usdt",
          type: "uint256",
        },
      ],
      name: "Sell",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        { indexed: true, internalType: "address", name: "to", type: "address" },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Transfer",
      type: "event",
    },
    {
      inputs: [],
      name: "AwardFundT",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "BuyBNBConnect",
      outputs: [{ internalType: "uint256", name: "id", type: "uint256" }],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [],
      name: "ExpenseFund",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "ExpenseWallet",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
      name: "GetExpense",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
      name: "GetRoyalty",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "ITFundT",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      name: "LC",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      name: "LP",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "LegalFundT",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "", type: "address" },
        { internalType: "uint256", name: "", type: "uint256" },
      ],
      name: "LevelCountribution",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "LevelFund",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "LevelIncomeWallet",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "", type: "address" },
        { internalType: "uint256", name: "", type: "uint256" },
      ],
      name: "LevelMemberCount",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "Liqudity",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "MarketingFundT",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "OnOffBuy",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "RoyaltyB",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "RoyaltyWalletC",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "_owner",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "addressToUserId",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "owner", type: "address" },
        { internalType: "address", name: "spender", type: "address" },
      ],
      name: "allowance",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "spender", type: "address" },
        { internalType: "uint256", name: "amount", type: "uint256" },
      ],
      name: "approve",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "user", type: "address" }],
      name: "balanceOf",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "bcc_Price",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "buyId",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      name: "buyRecord",
      outputs: [
        { internalType: "address", name: "cust_address", type: "address" },
        { internalType: "uint256", name: "bnb_amt", type: "uint256" },
        { internalType: "uint256", name: "bbcPrice", type: "uint256" },
        { internalType: "uint256", name: "token_to_user", type: "uint256" },
        { internalType: "uint256", name: "distribution_amt", type: "uint256" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "claimLevelIncome",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "customerId",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "decimals",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "distribute_level",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "getOwner",
      outputs: [{ internalType: "address", name: "", type: "address" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "user", type: "address" }],
      name: "getUserBuyRecords",
      outputs: [
        {
          components: [
            { internalType: "address", name: "cust_address", type: "address" },
            { internalType: "uint256", name: "bnb_amt", type: "uint256" },
            { internalType: "uint256", name: "bbcPrice", type: "uint256" },
            { internalType: "uint256", name: "token_to_user", type: "uint256" },
            {
              internalType: "uint256",
              name: "distribution_amt",
              type: "uint256",
            },
          ],
          internalType: "struct BnbConnectToken.Buyhistory[]",
          name: "",
          type: "tuple[]",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "user", type: "address" }],
      name: "getUserSellCount",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "user", type: "address" },
        { internalType: "uint256", name: "index", type: "uint256" },
      ],
      name: "getUserSellDetails",
      outputs: [
        { internalType: "uint256", name: "token", type: "uint256" },
        { internalType: "uint256", name: "bnbAmount", type: "uint256" },
        { internalType: "uint256", name: "adminFee", type: "uint256" },
        { internalType: "uint256", name: "finalAmount", type: "uint256" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "isBuyPause",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "isRegistered",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "levelClaimId",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      name: "levelClaimRecord",
      outputs: [
        { internalType: "address", name: "user", type: "address" },
        { internalType: "uint256", name: "amount", type: "uint256" },
        { internalType: "uint256", name: "time", type: "uint256" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "name",
      outputs: [{ internalType: "string", name: "", type: "string" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "payoutPercent",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "refer_address", type: "address" },
      ],
      name: "register",
      outputs: [{ internalType: "uint256", name: "custid", type: "uint256" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "uint256", name: "tokenAmount", type: "uint256" },
      ],
      name: "sellBCC",
      outputs: [{ internalType: "uint256", name: "id", type: "uint256" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "sellId",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      name: "sellRecord",
      outputs: [
        { internalType: "address", name: "cust_address", type: "address" },
        { internalType: "uint256", name: "token", type: "uint256" },
        { internalType: "uint256", name: "bnb_amt", type: "uint256" },
        { internalType: "uint256", name: "admin_amt", type: "uint256" },
        { internalType: "uint256", name: "final_amt", type: "uint256" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "symbol",
      outputs: [{ internalType: "string", name: "", type: "string" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalCollection",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "", type: "address" }],
      name: "totalLevelIncome",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalMint",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "recipient", type: "address" },
        { internalType: "uint256", name: "amount", type: "uint256" },
      ],
      name: "transfer",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "sender", type: "address" },
        { internalType: "address", name: "recipient", type: "address" },
        { internalType: "uint256", name: "amount", type: "uint256" },
      ],
      name: "transferFrom",
      outputs: [{ internalType: "bool", name: "", type: "bool" }],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
      name: "transferOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "", type: "address" },
        { internalType: "uint256", name: "", type: "uint256" },
      ],
      name: "userLevelClaimIds",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      name: "userRegister",
      outputs: [
        { internalType: "address", name: "customer_address", type: "address" },
        { internalType: "address", name: "referral_address", type: "address" },
        { internalType: "uint256", name: "totalDeposit", type: "uint256" },
        { internalType: "uint256", name: "totalSellBnb", type: "uint256" },
        { internalType: "uint256", name: "level_income", type: "uint256" },
        { internalType: "uint256", name: "totalbnbcSell", type: "uint256" },
        { internalType: "uint256", name: "directCount", type: "uint256" },
        { internalType: "uint256", name: "directBusiness", type: "uint256" },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        { internalType: "address", name: "", type: "address" },
        { internalType: "uint256", name: "", type: "uint256" },
      ],
      name: "userSellIds",
      outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
      stateMutability: "view",
      type: "function",
    },
  ];

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [userData, setUserData] = useState(null);
  const [report, setReport] = useState();
  const [sellData, setSellData] = useState([]);
  const [web3Instance, setWeb3Instance] = useState(null);
  const dataFetchedRef = useRef(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const getSellRecords = async () => {
    try {
      if (!walletAddress) return;

      // ✅ YE LAGAO
      const web3 = new Web3(
        new Web3.providers.HttpProvider("https://bsc-rpc.publicnode.com"),
      );
      const contract = new web3.eth.Contract(tokenABI, tokenAddress);

      let index = 0;

      setSellData([]);

      while (true) {
        try {
          const record = await contract.methods
            .getUserSellDetails(walletAddress, index)
            .call();

          if (!record || Object.keys(record).length === 0) break;

          const safeRecord = Object.fromEntries(
            Object.entries(record).map(([key, value]) => [
              key,
              typeof value === "bigint" ||
              (typeof value === "object" && value._isBigNumber)
                ? value.toString()
                : value,
            ]),
          );

          setSellData((prev) => [...prev, safeRecord]);

          index++;
        } catch (err) {
          console.log("No more records at index:", index);
          break;
        }
      }
    } catch (error) {
      console.error("Error fetching sell records:", error);
      alert(error.message);
    }
  };

  useEffect(() => {
    if (walletAddress && !dataFetchedRef.current) {
      getSellRecords();
      dataFetchedRef.current = true;
    }
  }, [walletAddress]);

  const formatEther = (value) => {
    return parseFloat(Web3.utils.fromWei(value.toString(), "ether")).toFixed(6);
  };

  return (
    <div className="bnbcontainer">
      <Grid container>
        <Grid item xs={12} md={12}>
          <Appbar handleDrawerToggle={handleDrawerToggle} />
        </Grid>

        <Grid item xs={12} md={12}>
          <Grid container spacing={2}>
            <Grid item md={2}>
              <Sidebar
                open={mobileOpen}
                handleDrawerToggle={handleDrawerToggle}
                userId={userId}
                setUserId={setUserId}
                userData={userData}
                setUserData={setUserData}
                walletAddress={walletAddress}
              />
            </Grid>
            <Grid item xs={12} md={10} sx={{ mt: "70px" }}>
              <Grid container spacing={3} p={3}>
                <Grid item xs={12} md={12}>
                  <Paper
                    elevation={3}
                    sx={{
                      backgroundColor: "#232529",
                      color: "white",
                      padding: "15px",
                      borderRadius: "10px",
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={12}>
                        <div className="headerconn">
                          <div
                            className="dashbheading"
                            onClick={() => {
                              navigate("/dashboard");
                            }}
                          >
                            Dashboard
                          </div>
                          <div className="subheading">/ Sell Report</div>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Paper
                    elevation={3}
                    sx={{
                      backgroundColor: "#232529",
                      color: "white",
                      borderRadius: "20px",
                    }}
                  >
                    <Grid container spacing={1}>
                      <Grid item xs={12} md={12}>
                        <div className="topuptitle">Sell Report</div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <hr />
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <Grid
                          container
                          spacing={2}
                          sx={{
                            paddingLeft: "30px",
                            paddingRight: "30px",
                            paddingBottom: "30px",
                            paddingTop: "10PX",
                          }}
                        >
                          <Grid item xs={12} md={12}>
                            <TableContainer>
                              <Table aria-label="simple table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell
                                      sx={{
                                        color: "white",
                                        py: 1,
                                        textAlign: "center",
                                      }}
                                    >
                                      Sr.No
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        color: "white",
                                        py: 1,
                                        textAlign: "center",
                                      }}
                                    >
                                      BCC Token
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        color: "white",
                                        py: 1,
                                        textAlign: "center",
                                      }}
                                    >
                                      BNB Amount
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {sellData.length > 0 ? (
                                    sellData.map((row, index) => (
                                      <TableRow
                                        key={index}
                                        sx={{
                                          borderBottom: "1px solid white",
                                        }}
                                      >
                                        <TableCell
                                          sx={{
                                            color: "white",
                                            textAlign: "center",
                                          }}
                                        >
                                          {index + 1}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            color: "white",
                                            textAlign: "center",
                                          }}
                                        >
                                          {formatEther(row.token)}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            color: "white",
                                            textAlign: "center",
                                          }}
                                        >
                                          {formatEther(row.bnbAmount)}
                                        </TableCell>
                                      </TableRow>
                                    ))
                                  ) : (
                                    <TableRow>
                                      <TableCell
                                        colSpan={3}
                                        sx={{
                                          color: "white",
                                          textAlign: "center",
                                          py: 2,
                                        }}
                                      >
                                        No Record Found
                                      </TableCell>
                                    </TableRow>
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default SellReport;
